import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Establish important cross-origin connections as early as the JS bundle allows.
const connectionHints = [
	["preconnect", "https://demo.riskydress.com"],
	["dns-prefetch", "https://demo.riskydress.com"],
	["preconnect", "https://admin.monsinidress.com"],
	["dns-prefetch", "https://admin.monsinidress.com"],
	["preconnect", "https://fonts.googleapis.com"],
	["preconnect", "https://fonts.gstatic.com", "anonymous"],
];

connectionHints.forEach(([rel, href, crossOrigin]) => {
	if (document.head.querySelector(`link[rel="${rel}"][href="${href}"]`)) return;
	const link = document.createElement("link");
	link.rel = rel;
	link.href = href;
	if (crossOrigin) link.crossOrigin = crossOrigin;
	document.head.appendChild(link);
});
// Load web fonts without making the Google Fonts stylesheet render-blocking.
const googleFontsHref =
	"https://fonts.googleapis.com/css2?family=Lora:wght@400;500;600;700&family=Poppins:wght@400;500;600;700&display=swap";

if (!document.head.querySelector(`link[href="${googleFontsHref}"]`)) {
	const fontStylesheet = document.createElement("link");
	fontStylesheet.rel = "stylesheet";
	fontStylesheet.href = googleFontsHref;
	fontStylesheet.media = "print";
	fontStylesheet.onload = () => {
		fontStylesheet.media = "all";
	};
	document.head.appendChild(fontStylesheet);
}


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
